var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _g, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTableIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H71.6667L75.5 4L80 8.5V64H30V0Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H71.6667V8.5H80V64H30V0Z",
    fill: "#E5E7EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 38,
    height: 4,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 38,
    height: 4,
    fill: "#F9FAFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 38,
    height: 4,
    fill: "#F9FAFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 44,
    width: 38,
    height: 4,
    fill: "#F9FAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0619 36.5974L26.9753 39.6523L13.6883 54.01C12.5857 55.2015 10.7065 55.2156 9.58615 54.0408L8.86538 53.285C7.74504 52.1103 7.84819 50.2339 9.09054 49.189L24.0619 36.5974Z",
    fill: "#D1D5DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_830_11487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 36,
    width: 19,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0619 36.5974L26.9753 39.6523L13.6883 54.01C12.5857 55.2015 10.7065 55.2156 9.58615 54.0408L8.86538 53.285C7.74504 52.1103 7.84819 50.2339 9.09054 49.189L24.0619 36.5974Z",
    fill: "#D1D5DB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_830_11487)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3897 45.0156C22.4573 44.3256 21.5712 43.5464 20.7433 42.6783C19.9154 41.8102 19.1791 40.8882 18.5341 39.9242L22.8302 36.311C23.374 37.2028 24.0208 38.0504 24.7711 38.8371C25.5214 39.6238 26.3374 40.3101 27.2024 40.8956L23.3897 45.0156Z",
    fill: "#9CA3AF"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 35.6405,
    y: 10,
    width: 26.7356,
    height: 26.7356,
    rx: 13.3678,
    transform: "rotate(46.3583 35.6405 10)",
    fill: "#FFB800",
    style: {
      mixBlendMode: "color"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6405,
    y: 10,
    width: 26.7356,
    height: 26.7356,
    rx: 13.3678,
    transform: "rotate(46.3583 35.6405 10)",
    stroke: "#D1D5DB",
    strokeWidth: 4.2214
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTableIllustration);
export default __webpack_public_path__ + "static/media/empty_table_illustration.2d3529661b37d03ba8a5f8d1fae3647e.svg";
export { ForwardRef as ReactComponent };